module.exports = __webpack_public_path__ + "static/images/union-pay-6733b28e.png";